import { ComponentPropsWithRef, forwardRef } from 'react';
import {
  Unstable_Grid2 as MUIGrid,
  GridProps as MUIGridProps,
} from '@mui/material';

export type GridProps = ComponentPropsWithRef<typeof Grid2>;

// https://stackoverflow.com/questions/75153171/warning-received-true-for-a-non-boolean-attribute-item
export const Grid2 = forwardRef<HTMLDivElement, MUIGridProps>(function Grid2(
  { item, ...props },
  ref,
) {
  return <MUIGrid ref={ref} {...props} />;
});
